import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import ValueCards from "@/components/site/ValueCards";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import FeaturedAI from "@/components/site/FeaturedAI";
import Process from "@/components/site/Process";
import Industries from "@/components/site/Industries";
import WhyUs from "@/components/site/WhyUs";
import CareersTeaser from "@/components/site/CareersTeaser";
import Portfolio from "@/components/site/Portfolio";
import Pricing from "@/components/site/Pricing";
import CTA from "@/components/site/CTA";
import Contact from "@/components/site/Contact";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";
import ChatWidget from "@/components/site/ChatWidget";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <ValueCards />
        <About />
        <Services />
        <FeaturedAI />
        <Process />
        <Industries />
        <WhyUs />
        <CareersTeaser />
        <Portfolio />
        <Pricing />
        <CTA />
        <Contact />
        <FAQ />
      </main>
      <Footer />
      <ChatWidget />
    </>
  );
}
